import { Env } from "../env";

export const prodEnv: Env = {
    backendUrl: 'https://m2pe6koy9j.execute-api.us-east-1.amazonaws.com/prod',
    cognito: {
        region: 'us-east-1',
        userPoolId: 'us-east-1_vZE7OjPWS',
        userPoolWebClientId: 'brp2vnkcqe6brvdhrhvhbbfj2',
    }
}